// extracted by mini-css-extract-plugin
export default {"action":"_210929b474a51578"};